import React from 'react';
import TableHeader from '../../../components/TableHeader';
import { fixedFloatAndCommas } from '../../../utils/conversion';

const View = ({ data, company, config, queryParameters, activeView, onRowClick, activeAssets, activeLiabilities }) => {
  return (
    <div className='inner-view'>
      <div className='trial-view'>
        <div className='top-header'>
          <h3>{company.title}</h3>
          <span>
            <b>Balance Sheet</b> as of date <b>{queryParameters.singleDate}</b>
          </span>
        </div>
        <div className='table-view'>
          <div className='cards one'>
            <div className='table-wrap'>
              <table>
                <thead className='one'>
                  <tr>
                    <th colSpan='2'>Assets</th>
                  </tr>
                </thead>
                <TableHeader headerDetails={config.header} />
                {config.getAssetsBody({
                  dataList: data.assetsLedgers,
                  activeView,
                  onRowClick,
                  activeData: activeAssets,
                  label: 'activeAssets',
                })}
              </table>
            </div>
            <footer >
              <p className='left-align'>Total</p>
              <p className='right-align'>{fixedFloatAndCommas(data.totalBalance.assets)}</p>
            </footer>
          </div>
          <div className='cards two'>
            <div className='table-wrap'>
              <table>
                <thead className='one'>
                  <tr>
                    <th colSpan='2'>Liability</th>
                  </tr>
                </thead>
                <TableHeader headerDetails={config.header} />
                {config.getLiabilityBody({
                  dataList: data.liabilitiesLedgers,
                  activeView,
                  activeData: activeLiabilities,
                  onRowClick,
                  label: 'activeLiabilities',
                })}
              </table>
            </div>
            <footer >
              <p className='left-align'>Total</p>
              <p className='right-align'>{fixedFloatAndCommas(data.totalBalance.liabilities)}</p>
            </footer>
          </div>
        </div>
      </div>
    </div>
  );
};

export default View;
